import { SUPPLEMENT_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";
import { OrderStatus, PaymentStatus } from "../types/orders";
import axios from "axios";
const BASE_URL = SUPPLEMENT_BASE_URL;

export interface OrderQueryParams {
  search?: string;
  status?: OrderStatus;
  payment_status?: PaymentStatus;
  date_from?: string;
  date_to?: string;
  page?: number;
  page_size?: number;
}

export const fetchOrders = async (params: OrderQueryParams = {}) => {
  const api = axiosAuth();

  const filteredParams = Object.fromEntries(
    Object.entries(params).filter(([_, v]) => v !== undefined && v !== ""),
  );

  const { data } = await api.get(`${BASE_URL}/orders/admin`, {
    params: filteredParams,
  });

  return data?.data.orders;
};

export const fetchAnalytics = async () => {
  const api = axiosAuth();

  const { data } = await api.get(`${BASE_URL}/orders/admin/count-amount`);

  return data?.data;
}

export const updateOrderStatus = async (orderId: string, status: string) => {
  const api = axiosAuth();

  const { data } = await api.patch(`${BASE_URL}/orders/admin/change-status`, {
    orderId: orderId,
    status: status,
  });

  return data;
};

export const fetchCustomerInfo = async (orderId: string) => {
  
  const res = await axios.get(
    `${SUPPLEMENT_BASE_URL}/orders/admin/order?order_id=${orderId}`,
  );

  return res?.data.data.order;
};